import { render, staticRenderFns } from "./CandidateIcon.vue?vue&type=template&id=027c357a&scoped=true&"
import script from "./CandidateIcon.vue?vue&type=script&lang=js&"
export * from "./CandidateIcon.vue?vue&type=script&lang=js&"
import style0 from "./CandidateIcon.vue?vue&type=style&index=0&id=027c357a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c357a",
  null
  
)

export default component.exports